import {
    collection,
    component,
    dateField,
    EntityData,
    field,
    identifier,
    LocalisableEntityData,
    transientField
} from "@fedeltapointofsale/data-client";
import {DiscountReferenceData} from "../discount/discount.data";
import {MixAndMatchReferenceData} from "../mix-and-match/mix-and-match.data";
import {SellableReferenceData} from "../../catalogue/sellable/sellable.data";
import {UncachedImageData} from "../../shared/image/uncached-image.data";
import {PeriodScheduleReferenceData} from "../../system/period-schedule/period-schedule.data";

export enum EntitlementStatus {
    ACTIVE = <any>"active",
    EXPIRED = <any>"expired",
    CONSUMED = <any>"consumed",
    DISCONTINUED = <any>"discontinued"
}

export class EntitlementDistributionChannelData extends EntityData<EntitlementDistributionChannelData> {
    @field distributionReference: string;
    @field distributionType: string = "Manual";
}

export class EntitlementProductData extends EntityData<EntitlementProductData> {
    @component sellable: SellableReferenceData;
    @field quantity: number;
}

export class EntitlementMemberContactData extends EntityData<EntitlementMemberContactData> {
    @identifier id: string;
    @field firstName: string;
    @field lastName: string;
}

export class EntitlementMemberData extends EntityData<EntitlementMemberData> {
    @identifier memberNo: string;
    @field integratedLoyaltyId: string;
    @component contact: EntitlementMemberContactData;
}

export class EntitlementData extends LocalisableEntityData<EntitlementData> {
    @identifier id: number;
    @field externalId: string;
    @dateField issueDate: Date = new Date();
    @dateField expiryDate: Date;
    @field usageLimit: number;
    @field usageCount: number = 0;
    @field status: EntitlementStatus;
    @field scheduleRequired: boolean = false;
    @field showAppDealCard: boolean = true;
    @field selectByDealCodeInApp: boolean = false;
    @field featureOnAppMenu: boolean = true;
    @field suppressDealCardIfAnyOrdered: boolean = true;
    @field suppressDealCardIfOrdered: boolean = true;
    @field showAppQrCode: boolean = false;
    @field orderAhead: boolean = true;
    @field orderDelivery: boolean = true;
    @field orderAtTable: boolean = true;
    @component distributionChannel: EntitlementDistributionChannelData;
    @field mixAndMatchId: number;
    @component mixAndMatch: MixAndMatchReferenceData;
    @component discount: DiscountReferenceData;
    @field memberNo: number;
    @component member: EntitlementMemberData;
    @field membershipTypeIds: number[] = [];
    @field includeGuests: boolean;
    @component image: UncachedImageData;
    @field imageAutoCrop: boolean = false;
    @field appText1: string;
    @field appText2: string;
    @field showTitleOnDealCard: string;
    @field showActionButtonOnDealCard: boolean = true;
    @collection(EntitlementProductData) products: EntitlementProductData[];
    @collection(PeriodScheduleReferenceData) periodSchedules: PeriodScheduleReferenceData[];

    @transientField discontinued: boolean;
    @transientField get derivedStatus(): EntitlementStatus {
        return this.discontinued ? EntitlementStatus.DISCONTINUED
            : this.expiryDate < new Date() ? EntitlementStatus.EXPIRED
                : this.usageLimit && this.usageCount >= this.usageLimit ? EntitlementStatus.CONSUMED
                    : EntitlementStatus.ACTIVE;
    }
    set derivedStatus(status: EntitlementStatus) {
    }

    override onLoad(): void {
        this.discontinued = this.status == EntitlementStatus.DISCONTINUED;
    }
}

export class EntitlementDistributionChannelReferenceData extends EntityData<EntitlementDistributionChannelReferenceData> {
    @field distributionReference: string;
}

export class EntitlementReferenceData extends EntityData<EntitlementReferenceData> {
    @identifier id: number;
    @field externalId: string;
    @component distributionChannel: EntitlementDistributionChannelReferenceData;

    @transientField get summary(): String {
        return this.distributionChannel.distributionReference + (this.externalId ? " - " + this.externalId : "" );
    }
}

